import * as React from 'react';

import type { NextPage } from 'next';

import { SignInPage } from '@itp/talent/pages/auth/signIn';

const Page: NextPage = () => {
  return (
    <>
      <SignInPage />
    </>
  );
};

export default Page;
